// TODO: just for the demo purpose, this file will be removed
import React from "react";
import { IUniversalTableData, IUniversalTableColumn } from '../interfaces';
import GetAppIcon from "@material-ui/icons/GetApp";
import RestoreIcon from "@material-ui/icons/Restore";

const handleLinkClick = (index) => {
    console.log('handleLinkClick: ', index)
}

const handleButtonClick = (index) => {
    console.log("handleDownloadClick: ", index);
};

const handleRestartClick = (index) => {
    console.log("handleRestartClick: ", index);
};

const handleShowFilesClick = (index: number) => {
    console.log('handleShowFiles: ', index);
}

export const demoColumns: IUniversalTableColumn[] = [
    // this column will contain a link with text taken from 'orderNo' field from data
    {
        type: 'link',
        title: 'Order no.',
        field: 'orderNo',
        // onClick callback can be set, it receives index of the row
        onClick: (index) => handleLinkClick(index)
    },
    // normal text field, text is taken from 'createdOn' field from data
    {
        type: 'text',
        title: 'Created on',
        field: 'createdOn',
    },
    {
        type: 'text',
        title: "Total amount",
        field: 'vat',
    },
    {
        type: 'text',
        title: 'Status',
        field: 'status'
    },
    // column will contain a button with text taken from 'buttonTitle' property
    {
        type: 'button',
        title: "Files",
        buttonTitle: 'Show Files',
        // onClick callback can be set, it receives index of the row
        onClick: (index) => handleShowFilesClick(index)
    },
    {
        type: "actions",
        title: "Actions",
        // definition of actions, they will be in the last column of a table
        actions: [
            {
                name: "download", // for identification
                icon: <GetAppIcon />,
                tooltip: "Download",
                // onClick callback can be set, it receives index of the row
                onClick: (index) => handleButtonClick(index),
            },
            {
                name: "restart",
                icon: <RestoreIcon />,
                tooltip: "Restart",
                onClick: (index) => handleRestartClick(index),
            },
        ],
    },
];

export const demoData: IUniversalTableData  = [
    {
        orderNo: '12345',
        createdOn: '20210103',
        vat: 20,
        status: 'Archived',
        // user can optionally set which action will be disabled for particular row
        actionsDisabled: ['download']
    },
    {
        orderNo: '23456',
        createdOn: '20200102',
        vat: 30,
        status: 'Best',
        actionsDisabled: ['restart']
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed',
        actionsDisabled: ['download', 'restart']
    },
    {
        orderNo: '12345',
        createdOn: '20200102',
        vat: 20,
        status: 'Best',
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
    {
        orderNo: '12345',
        createdOn: '20200101',
        vat: 20,
        status: 'Completed'
    },
];
